import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';

const TestimonialsSection: React.FC = () => {
  return (
    <section className="testimonial-section py-5" id="testimonials">
      <Container>
        <h2 className="text-center mb-5 fw-bold fs-2 text-white">What Our Customers Say</h2>
        <Row>
          <Col md={4}>
            <Card className="testimonial-card">
              <CardBody>
                <img
                  src="https://placehold.co/90x90/cccccc/333333?text=Laura&font=Inter"
                  alt="Laura Bennett, CTO of TechCorp Solutions"
                />
                <p>
                  This platform transformed how we manage our tenants, saving us hours of manual
                  work.
                </p>
                <p className="fw-bold">Laura Bennett</p>
                <p className="text-muted">CTO, TechCorp Solutions</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="testimonial-card">
              <CardBody>
                <img
                  src="https://placehold.co/90x90/cccccc/333333?text=James&font=Inter"
                  alt="James Patel, CFO of Innovate SaaS"
                />
                <p>
                  The subscription dashboard provides unmatched visibility into our billing cycles.
                </p>
                <p className="fw-bold">James Patel</p>
                <p className="text-muted">CFO, Innovate SaaS</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="testimonial-card">
              <CardBody>
                <img
                  src="https://placehold.co/90x90/cccccc/333333?text=Emma&font=Inter"
                  alt="Emma Wong, CEO of CloudPeak Enterprises"
                />
                <p>The support ticketing system made customer service seamless and efficient.</p>
                <p className="fw-bold">Emma Wong</p>
                <p className="text-muted">CEO, CloudPeak Enterprises</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TestimonialsSection;
